export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-container site-footer__inner">
        <span>© {new Date().getFullYear()} Eli Schatz</span>
        <div className="site-footer__links">
          <a href="https://www.linkedin.com/in/eli-schatz/" rel="noreferrer" target="_blank">LinkedIn</a>
          <a href="https://github.com/Eli-Schatz" rel="noreferrer" target="_blank">GitHub</a>
          <a href="mailto:eschatz36@gmail.com">Email</a>
        </div>
      </div>
    </footer>
  );
}
